module.exports = __webpack_public_path__ + "static/media/Lock.57d15909.svg";